import { connect } from 'react-redux';
import {
    completeMfaSignIn,
    setLockedUserRedirect,
} from './mfaVerificationFormActions';
import { MFAVerificationFormContainer } from './MFAVerificationFormContainer';

const mapStateToProps = (state) => {
    if (!state?.signInForm) {
        throw new Error(
            'MFAVerificationForm: Expected the sign in state to be available as `state.signInForm`. ' +
                "Ensure you have added the `signInReducer` to your store's reducers via `combineReducers`."
        );
    }

    return {
        email: state.signInForm.email,
        responseBody: state.signInForm.responseBody,
        signedIn: state.signInForm.signedIn,
        suggestedRedirect: state.signInForm.suggestedRedirect,
    };
};

const mapDispatchToProps = (dispatch) => ({
    onSuccessfulAuthentication: (responseBody) => {
        dispatch(completeMfaSignIn(responseBody));
    },
    redirectLockedUser: (responseBody) => {
        dispatch(setLockedUserRedirect(responseBody));
    },
});

export const MFAVerificationForm = connect(
    mapStateToProps,
    mapDispatchToProps
)(MFAVerificationFormContainer);
